/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownDegreeOutcome } from '../models/db_DropdownDegreeOutcome';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DegreeOutcomes {
    /**
     * Get a list of degree outcomes
     * @returns db_DropdownDegreeOutcome OK
     * @throws ApiError
     */
    public static listDegreeOutcomes(): CancelablePromise<Array<db_DropdownDegreeOutcome>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/degree-outcomes',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
